import React from 'react';
import { Alert } from "react-bootstrap";

/**
 * ErrorBanner component displays an Alert banner with a danger variant, showing an error message.
 * @param {Object} props - Component props
 * @param {string} props.errorText - The error message to be displayed
 * @returns {JSX.Element|null} - JSX element representing the ErrorBanner component, or null if errorText is falsy
 */
export default function ErrorBanner({ errorText }) {
    return (
        <>
            {errorText && <Alert variant="danger">{errorText}</Alert>}
        </>
    );
}
